export class HorseTipsterModel {
  id: number;
  nickname: string;
  inRaceTipsRanking: string;
  inRaceTipsScore: string;
  inRaceTipsProfitability: string;
  inRaceTipsAccuracy: string;
  inRaceTipsTotalSoldCount: number;
  inRaceTipsProfitabilityRanking: number;
  inRaceTipsAccuracyRanking: number;
  tipsPackageRanking: string;
  tipsPackageScore: string;
  tipsPackageProfitability: string;
  tipsPackageAccuracy: string;
  tipsPackageTotalSoldCount: number;
  tipsPackageProfitabilityRanking: number;
  tipsPackageAccuracyRanking: number;
  defaultTipsPrice: number;
  defaultTipsPackagePrice: number;
  biographyTitle: string;
  biographyDetail: string;
  subscribeType: number;
  subscriberType: number;
  highestScore: number = -1;
  currentProfitMargin: number;

  constructor(id: number, nickname: string, inRaceTipsRanking: string, inRaceTipsScore: string,inRaceTipsProfitability: string,
    inRaceTipsAccuracy: string, inRaceTipsTotalSoldCount: number, inRaceTipsProfitabilityRanking: number, inRaceTipsAccuracyRanking: number,
    tipsPackageRanking: string, tipsPackageScore: string, tipsPackageProfitability: string, tipsPackageAccuracy: string,
    tipsPackageTotalSoldCount: number, tipsPackageProfitabilityRanking: number, tipsPackageAccuracyRanking: number, defaultTipsPrice: number,
    defaultTipsPackagePrice: number, biographyTitle: string, biographyDetail: string, subscribeType: number, subscriberType: number, highestScore: number,
    currentProfitMargin: number) {
    this.id = id;
    this.nickname = nickname;
    this.inRaceTipsRanking = inRaceTipsRanking;
    this.inRaceTipsScore = inRaceTipsScore;
    this.inRaceTipsProfitability = inRaceTipsProfitability;
    this.inRaceTipsAccuracy = inRaceTipsAccuracy;
    this.inRaceTipsTotalSoldCount = inRaceTipsTotalSoldCount;
    this.inRaceTipsProfitabilityRanking = inRaceTipsProfitabilityRanking;
    this.inRaceTipsAccuracyRanking = inRaceTipsAccuracyRanking;
    this.tipsPackageRanking = tipsPackageRanking;
    this.tipsPackageScore = tipsPackageScore;
    this.tipsPackageProfitability = tipsPackageProfitability;
    this.tipsPackageAccuracy = tipsPackageAccuracy;
    this.tipsPackageTotalSoldCount = tipsPackageTotalSoldCount;
    this.tipsPackageProfitabilityRanking =  tipsPackageProfitabilityRanking;
    this.tipsPackageAccuracyRanking = tipsPackageAccuracyRanking;
    this.defaultTipsPrice = defaultTipsPrice;
    this.defaultTipsPackagePrice = defaultTipsPackagePrice;
    this.biographyTitle = biographyTitle;
    this.biographyDetail = biographyDetail;
    this.subscribeType = subscribeType;
    this.subscriberType = subscriberType;
    this.highestScore = highestScore;
    this.currentProfitMargin = currentProfitMargin;
  }


}



// WEBPACK FOOTER //
// ./src/model/horse/HorseTipsterModel.ts